import { FormattedMessage, useIntl } from 'react-intl';
import { FilterItem } from '@molecules/filters/filtersMenu';
import { FilterGeneral } from '@libs/store/filters';

type StatusFilterMenuProps = {
  localizationSubset: string;
  getFilter: (key: string) => FilterGeneral<string[]> | null;
  key: string;
};
export function useStatusFilterMenu({ localizationSubset, getFilter, key }: StatusFilterMenuProps): FilterItem {
  const intl = useIntl();
  const filter = getFilter(key);

  return {
    label: <FormattedMessage id={`${localizationSubset}.filters.${key}.label`} />,
    key: key,
    multiple: true,
    valueToLabel: (value) =>
      value.map((v) => intl.formatMessage({ id: `shifts.status.${v.toLowerCase()}` })).join(', '),
    children: [
      {
        label: <FormattedMessage id="shifts.status.opened" />,
        key: 'Opened',
      },
      {
        label: <FormattedMessage id="shifts.status.pending" />,
        key: 'Pending',
      },
      {
        label: <FormattedMessage id="shifts.status.assigned" />,
        key: 'Assigned',
      },
      {
        label: <FormattedMessage id="shifts.status.reassigned" />,
        key: 'Reassigned',
      },
      {
        label: <FormattedMessage id="shifts.status.canceled" />,
        key: 'Canceled',
      },
      {
        label: <FormattedMessage id="shifts.status.inprogress" />,
        key: 'InProgress',
      },
      {
        label: <FormattedMessage id="shifts.status.unfilled" />,
        key: 'Unfilled',
      },
      {
        label: <FormattedMessage id="shifts.status.deleted" />,
        key: 'Deleted',
      },
      {
        label: <FormattedMessage id="shifts.status.expired" />,
        key: 'Expired',
      },
      {
        label: <FormattedMessage id="shifts.status.unassigned" />,
        key: 'Unassigned',
      },
      {
        label: <FormattedMessage id="shifts.status.completed" />,
        key: 'Completed',
      },
    ].map((item) => ({
      ...item,
      selected: filter?.value.includes(item.key) || false,
    })),
  };
}
